import React, { lazy, Suspense } from "react";
import { createPortal } from "react-dom";
const BaseToast = lazy(() =>
  import("@mbo/form-advanced").then((module) => ({
    default: module.Toast,
  })),
);
import { BodyText } from "@mbo/typography";
import { StyledWrapper } from "./toast.style";

const Toast = ({ showToast, success, message, autoCloseTime = 4000 }) => {
  if (!showToast) return null;

  return createPortal(
    <StyledWrapper>
      <Suspense>
        {showToast && (
          <BaseToast
            toastType={success ? "success" : "error"}
            autoClose
            autoCloseTime={autoCloseTime}
          >
            <BodyText color="dark" size="lg">
              {message}
            </BodyText>
          </BaseToast>
        )}
      </Suspense>
    </StyledWrapper>,
    document.body,
  );
};

export default Toast;
